import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const LinedStar: FunctionalComponent<IIconProps> = ({ width = '16', height = '16', fill = '#333' }) => (
  /*@ts-ignore*/
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 40 40">
    <path
      fill={fill}
      fill-rule="evenodd"
      d="M12.714 35.516c-1.36.708-3.043.19-3.758-1.157-.284-.536-.383-1.15-.28-1.748l1.392-8.035-5.894-5.69c-1.1-1.062-1.123-2.807-.05-3.897.427-.434.986-.716 1.592-.803l8.146-1.172 3.643-7.31c.68-1.366 2.348-1.926 3.726-1.252.55.268.993.708 1.264 1.251l3.643 7.31 8.146 1.173c1.52.219 2.575 1.617 2.354 3.123-.088.6-.374 1.154-.812 1.577l-5.894 5.69 1.391 8.035c.26 1.5-.757 2.925-2.272 3.182-.603.102-1.223.005-1.765-.277L20 31.723l-7.286 3.793zm5.991-7.27c.81-.422 1.78-.422 2.59 0l6.054 3.152-1.156-6.677c-.155-.893.144-1.805.8-2.439l4.898-4.728-6.769-.974c-.906-.13-1.69-.694-2.095-1.507L20 8.998l-3.027 6.075c-.405.813-1.189 1.377-2.095 1.507l-6.77.974 4.899 4.729c.656.633.955 1.545.8 2.438l-1.156 6.677 6.054-3.152z"
      clip-rule="evenodd"
    />
  </svg>
);

export default LinedStar;
